import { REFERRAL_URL_TYPE } from '../constants';

const BASE_URL = `${process.env.REACT_APP_BASE_URL}/patient/`;
export const QRCODE_QUERY_PARAM = '?qr';

export function generateReferralURL(
  referralHash: string,
  type: REFERRAL_URL_TYPE = REFERRAL_URL_TYPE.LINK
): string {
  return `${BASE_URL}${referralHash}${type === REFERRAL_URL_TYPE.QRCODE ? QRCODE_QUERY_PARAM : ''}`;
}
